import React, { PureComponent } from 'react';
import styled from 'styled-components';

import CloseIcon from '../../../CloseButton/CloseIcon';

// import mediaWidth from '../../../../utils/mediaWidth/mediaWidth';
// import color from '../../../../utils/colors';

export default class CloseButton extends PureComponent {
    render() {
        const {
            className, onClick,
        } = this.props;

        return (
            <Root className={className} onClick={onClick}>
                <CloseIconStyled className="icon" />
            </Root>
        );
    }
}

const Root = styled.button`
    padding: 0px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;

    :hover .icon {
        stroke: #0032A0;
    }

    :active .icon {
        stroke: #002679;
    }
`;

const CloseIconStyled = styled(CloseIcon)`
    stroke: #000000;
`;
